import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "universal-cookie";
import { useEffect } from "react";

import Loading from "../../../../components/common/Loading/Loading";

const TikTokAuth = () => {
	const [searchParams] = useSearchParams();

	const navigate = useNavigate();

	useEffect(() => {
		const appKey = searchParams.get("app_key");
		const code = searchParams.get("code");
		const locale = searchParams.get("locale");
		const shopRegion = searchParams.get("shop_region");

		if (appKey && code) {
			const cookies = new Cookies();
			const domain = window.location.hostname;

			cookies.set(
				"tiktokAuthData",
				JSON.stringify({ appKey, code, locale, shopRegion }),
				{
					path: "/",
					domain: domain,
					sameSite: "lax",
					secure: true,
				}
			);
			navigate("/register?from=tiktok");
		}
	}, [searchParams, navigate]);

	return (
		<div style={{ minHeight: "50vh" }} className="d-flex">
			<Loading isLoading={true}>
				<div></div>
			</Loading>
		</div>
	);
};

export default TikTokAuth;
